import http from "../../../NetworkServices/http";

let consoleBaseUrl = process.env.REACT_APP_CH_CONSOLE_API_BASE_URL;
consoleBaseUrl = consoleBaseUrl + "api/v1";

export class SubAccountNetworkService {
  static getSubAccountsListing(data: any) {
    const { limit, offset, search, timezone, status } = data;
    const params = { offset, limit, search, timezone, filter: status };
    return http.get(`${consoleBaseUrl}${Endpoints.GET_DASHBOARD_USERS}`, {
      params,
    });
  }
  static getSubAccountsCredit(data: any) {
    const { workspace_id } = data;
    return http.get(
      `${consoleBaseUrl}${Endpoints.GET_DASHBOARD_USERS}?workspace_id=${workspace_id}`
    );
  }
  static getSubAccountsCreditsLogs(data: any) {
    // const { workspace_id } = data;
    return http.post(`${consoleBaseUrl}${Endpoints.GET_CREDIT_LOGS}`, data);
  }
  static getSlefCreditsLogs(data: any) {
    // const { workspace_id } = data;
    return http.post(
      `${consoleBaseUrl}${Endpoints.GET_SELF_CREDIT_LOGS}`,
      data
    );
  }
  static updateAccountStatus(data: any) {
    const { id, status } = data;
    return http.put(
      `${consoleBaseUrl}${Endpoints.UPDATE_ACCOUNT_STATUS}/${id}`,
      { status: status }
    );
  }
  static manageCredits(data: any) {
    const { workspace_id, credit, reason } = data;
    if (data.action === "add") {
      return http.post(`${consoleBaseUrl}${Endpoints.ADD_ACCOUNT_CREDITS}`, {
        workspace_id: workspace_id,
        credit: credit,
        reason: reason,
      });
    } else {
      return http.post(`${consoleBaseUrl}${Endpoints.REMOVE_ACCOUNT_CREDITS}`, {
        workspace_id: workspace_id,
        credit: credit,
        reason: reason,
      });
    }
  }
  static getSubAccountPricing(data: any) {
    const { channel, payload } = data;
    return http.post(
      `${consoleBaseUrl}${Endpoints.GET_ACCOUNT_PRICING}/${channel}`,
      payload
    );
  }

  // for Domain

  static getDomainDetails(data: any) {
    return http.post(`${consoleBaseUrl}${Endpoints.GET_DOMAIN_DETAILS}`, data);
  }
  static setSubAccountPricing(data: any) {
    const { workspace_id, payload } = data;
    return http.put(
      `${consoleBaseUrl}${Endpoints.SET_ACCOUNT_PRICING}/${workspace_id}`,
      payload
    );
  }
  static getPricingPlan(data: any) {
    const { workspace_id } = data;
    return http.get(
      `${consoleBaseUrl}${Endpoints.GET_PRICING_PLAN}/${workspace_id}`
    );
  }
  static getPlansForMaster(data: any) {
    return http.post(`${consoleBaseUrl}${Endpoints.GET_MASTER_PLANS}`, data);
  }

  static setDisableUser(data: any) {
    const { workspace_id } = data;
    return http.get(
      `${consoleBaseUrl}${Endpoints.SET_DISABLE_USER}/${workspace_id}`
    );
  }

  static setResetPassword(data: any) {
    return http.put(`${consoleBaseUrl}${Endpoints.SET_RESET_PASSWORD}`, data);
  }

  static setUpgradePlan(data: any) {
    return http.put(`${consoleBaseUrl}${Endpoints.SET_UPGRADE_PLAN}`, data);
  }

  static getBroadcastSummaryLogs(data: any) {
    const { limit, offset, search, timezone, start_date, end_date, workspace_ids } = data;
    const params = { offset, limit, search, timezone, start_date, end_date, sub_acc_filter: workspace_ids };
    return http.get(`${consoleBaseUrl}${Endpoints.GET_BROADCAST_SUMMARY_LOGS}`, {
      params,
    });
  }

  static getSubAccountsDropdownListing() {
    return http.get(`${consoleBaseUrl}${Endpoints.GET_SUBACCOUNTS_DROPDOWN}`);
  }



  // static setRenewSubscription(data: any) {
  //   debugger;
  //   const { workspace_id } = data;
  //   return http.put(
  //     `${consoleBaseUrl}${Endpoints.SET_RENEW_SUBSCRIPTION}/${workspace_id}`,
  //     data
  //   );
  // }
}

class Endpoints {
  static GET_DASHBOARD_USERS = "/workspace/sub-accounts/list/";
  static GET_CREDIT_LOGS = "/workspace/reseller/credit-sharing-logs";
  static GET_SELF_CREDIT_LOGS = "/workspace/reseller/self-credit-sharing-logs";
  static UPDATE_ACCOUNT_STATUS = "/workspace/sub-accounts/update-status";
  static ADD_ACCOUNT_CREDITS = "/workspace/reseller/credit-sharing/add";
  static REMOVE_ACCOUNT_CREDITS = "/workspace/reseller/credit-sharing/remove";
  static GET_ACCOUNT_PRICING = "/workspace/sub-accounts/get-credit-rates";
  static SET_ACCOUNT_PRICING = "/workspace/sub-accounts/update-rates";
  static GET_PRICING_PLAN = "/core/subscription/get-plans";
  static GET_DOMAIN_DETAILS = "/workspace/get-domain-details";
  static GET_MASTER_PLANS = "/core/subscription/get-plans-for-master";
  static SET_DISABLE_USER =
    "/core/subscription/disable_subscription_from_admin";
  static SET_UPGRADE_PLAN = "/core/subscription/update-subaccount-subscription";
  static SET_RESET_PASSWORD="/workspace/sub-accounts/reset-user-password"
  static GET_BROADCAST_SUMMARY_LOGS = "/workspace/analytics/broadcast-summary-logs";
  static GET_SUBACCOUNTS_DROPDOWN = "/workspace/sub-accounts/dropdown-list/";

  // static SET_RENEW_SUBSCRIPTION =
  //   "/core/subscription/renew_subscription_from_admin";
}
